import { Building2, ShieldCheck } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { useBankAuth } from '@/lib/bank/auth'

export default function BankImportLCEntry() {
  const { principal } = useBankAuth()

  if (!principal) {
    return null
  }

  return (
    <main className="min-h-screen bg-muted/30 px-4 py-12 sm:px-6">
      <Card className="mx-auto max-w-3xl">
        <CardHeader className="space-y-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            <ShieldCheck aria-hidden="true" className="h-6 w-6" />
          </div>
          <div className="space-y-2">
            <CardTitle>Bank Import LC access confirmed</CardTitle>
            <CardDescription>
              Your bank identity and working scope are verified. Operational
              Import LC tools will appear here when their canonical APIs are
              available.
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <dl className="grid gap-6 sm:grid-cols-2">
            <div className="space-y-2">
              <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
                <Building2 aria-hidden="true" className="h-4 w-4" />
                Bank ID
              </dt>
              <dd className="break-all font-mono text-sm">
                {principal.bank_id}
              </dd>
            </div>
            <div className="space-y-2">
              <dt className="text-sm font-medium text-muted-foreground">
                Branch scope
              </dt>
              <dd>
                {principal.all_branches ? (
                  <span className="text-sm">All authorized branches</span>
                ) : (
                  <ul className="space-y-1">
                    {principal.branch_ids.map((branchId) => (
                      <li
                        className="break-all font-mono text-sm"
                        key={branchId}
                      >
                        {branchId}
                      </li>
                    ))}
                  </ul>
                )}
              </dd>
            </div>
            <div className="space-y-2 sm:col-span-2">
              <dt className="text-sm font-medium text-muted-foreground">
                Workflow roles
              </dt>
              <dd className="flex flex-wrap gap-2">
                {principal.roles.map((role) => (
                  <Badge key={role} variant="secondary">
                    {role}
                  </Badge>
                ))}
              </dd>
            </div>
          </dl>
        </CardContent>
      </Card>
    </main>
  )
}
